import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { BaseRes } from 'bff/models/base/baseRes';
import { PromotionList, PrizeWinner, ValueAdd, Promotion } from 'bff/models/promotion';
import { Activities, Activity } from 'bff/models/info';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import { PromotionEventType } from 'constants/enums/promotionEventType.enum';

/**
 * @description 取得優惠活動列表頁初始化資料
 */
const fetchInitSetting = async () => {
  const baseReq = commonService.getApiReqData();
  const reqConfig = commonService.getReqConfig();
  const promotionReq = commonService.getApiReqData({ EVENT_TYPE: PromotionEventType.All });

  const result = await Promise.all([
    apiService.fetchPromotionList(promotionReq, reqConfig),
    apiService.fetchActivities(baseReq, reqConfig)
  ]).then(([promotionListRes, activitiesRes]) => {
    const promotionListBaseRes:BaseRes<PromotionList> = { ...promotionListRes };
    const activitiesBaseRes:BaseRes<Activities> = { ...activitiesRes };
    const res = {
      promotionList: { ...promotionListBaseRes.TRANRS },
      activities: {
        MORE_ACTIVITY_URL: activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL ? activitiesBaseRes.TRANRS.MORE_ACTIVITY_URL : '',
        ACTIVITY: activitiesBaseRes.TRANRS.ACTIVITY ? [...activitiesBaseRes.TRANRS.ACTIVITY.sort((first:Activity, second:Activity) => +first.SHOW_ORDER - +second.SHOW_ORDER)] : new Array(0)
      }
    };

    return res;
  });

  return result;
};

/**
 * @description 查詢得獎公告內容
 * @param sn 優惠活動編號
*/
const fetchPrizeWinnerInfo = async (sn:number) => {
  const baseReq = commonService.getApiReqData({ SN: sn });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchPrizeWinner(baseReq, reqConfig).then((res:BaseRes<PrizeWinner>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.PRIZE_WINNER;
  }
};

/**
 * @description 查詢加值服務內容
 * @param sn 優惠活動編號
*/
const fetchValueAdd = async (sn:number) => {
  const baseReq = commonService.getApiReqData({ SN: sn });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchValueAdd(baseReq, reqConfig).then((res:BaseRes<ValueAdd>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.VALUE_ADD;
  }
};

/**
 * @description 查詢優惠活動內容
 * @param sn 優惠活動編號
*/
const fetchPromotion = async (sn:number) => {
  const baseReq = commonService.getApiReqData({ SN: sn });
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.fetchPromotion(baseReq, reqConfig).then((res:BaseRes<Promotion>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.PROMOTION;
  }
};

export default {
  fetchInitSetting,
  fetchPrizeWinnerInfo,
  fetchValueAdd,
  fetchPromotion
};
